'use client';

// This is a dummy component that is used to load global imports
const LoadGlobalImports = () => null;

export default LoadGlobalImports;
